export const NEW_HOLDER_ONBOARDED_ATTRIBUTE_KEY = 'sr_new_holder_onboarded';
